import React from 'react'

const Dashboard = props => {
    return (
        <p>Admin dashboard goes here</p>
    )
}

export default Dashboard